<template>
  <b-modal id="comments-view-modal" :modal-class="`adp-modal`" :body-class="`adp-modal-body`"
           :header-class="`adp-modal-header`" :footer-class="`adp-modal-footer d-flex justify-content-center`">
    <template #modal-title>
      <h5 class="modal-title adp-h2 adp-h2__modal">{{ name }}</h5>
    </template>
    <template #modal-header-close>
      <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
    </template>
    <template>
      <div class="adp-p adp-p__grey">{{ comments.length }} {{ $tc('idp.comment', comments.length) }}</div>
      <div class="adp-comment-row" :class="{'adp-comment-row__owner' : comment.pernumber === viewerPernumber}"
           v-for="comment in comments"
      >
        <div class="adp-comment">
          <div class="adp-p adp-p__grey" v-if="comment.pernumber === viewerPernumber">Вы</div>
          <div class="adp-p adp-p__grey" v-else>{{ comment.position }} {{ comment.name }}</div>
          <div class="adp-comment-message">
            <div class="adp-p adp-p__bold" style="margin-bottom: 2px;">{{ comment.text }}</div>
            <div class="adp-p adp-p__grey">{{ getDisplayDate(comment.created_at) }}</div>
          </div>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <button class="btn btn-primary adp-btn adp-btn__large" style="margin-left: auto" v-if="role !== 'admin'"
              @click="showCommentsCreateModal()">
        {{ $t('idp.cm_comment') }}
      </button>
      <div v-if="role === 'admin'"></div>
    </template>
  </b-modal>
</template>

<script>

import CommentsCreateModal from "./CommentsCreateModal";

export default {
  name: "CommentsViewModal",
  components: {
    'comments-create-modal': CommentsCreateModal,
  },
  props: {
    comments: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    viewerPernumber: {
      type: Number,
      required: true,
    },
    learningActivityId: {
      type: Number,
      required: true,
    },
  },
  data: () => {
    return {
      role: '',
    }
  },
  methods: {
    getDisplayDate(datetime) {
      let tokens = datetime.split(' ')
      let date = tokens[0];

      let time = tokens[1];
      let timeStr = `${this.$t('voc.at')} ${time.slice(0, 5)}`;

      let today = new Date();
      today.setHours(0);
      today.setMinutes(0);
      today.setSeconds(0);
      today.setMilliseconds(0);

      let datePart = date.match(/\d+/g);
      const year = datePart[0];
      const month = datePart[1];
      const day = datePart[2];
      let compDate = new Date(year, month - 1, day); // month - 1 because January == 0
      let diff = today.getTime() - compDate.getTime();

      if (compDate.getTime() === today.getTime()) {
        return `${this.$t('voc.today')} ${timeStr}`;
      } else if (diff <= (24 * 60 * 60 * 1000)) {
        return `${this.$t('voc.yesterday')} ${timeStr}`;
      } else {
        return `${day}.${month}.${year} ${timeStr}`;
      }
    },
    showCommentsCreateModal() {
      this.$bvModal.show('comments-create-modal');
    },
  },
  mounted() {
    this.role = window.IDP.role;
  }
}
</script>
